import { apiClient } from '~/adapters/apiClient';
import log from '~/logger';
export async function fetchProductsByModelIds(modelIds) {
    if (modelIds.length === 0) {
        return [];
    }
    const url = `/product_planning/products/v1?filter=modelId(${modelIds.join(',')})`;
    try {
        const data = await apiClient.get(url, 'pulse-bff');
        const activeProducts = data.objects
            .filter((product) => product.active === true)
            .map((product) => ({
            id: product.id,
            modelId: product.modelId
        }));
        return activeProducts;
    }
    catch (error) {
        log.error('Failed to fetch products by model IDs', {
            error: error instanceof Error ? error.message : 'Unknown error',
            modelIds
        });
        return [];
    }
}
